import { render } from "./modal-success.vue?vue&type=template&id=cedfa582&scoped=true&ts=true"
import script from "./modal-success.vue?vue&type=script&lang=ts"
export * from "./modal-success.vue?vue&type=script&lang=ts"

import "./modal-success.vue?vue&type=style&index=0&id=cedfa582&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cedfa582"]])

export default __exports__